export let CartContextKey: string = 'checkout-storage'
export let ManufacturerId: string = 'manufacturer-id'
